"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.math = void 0;
const create_fn_1 = require("../utils/create-fn");
const get_arg_1 = require("../utils/get-arg");
const unsupported_fn_1 = require("../utils/unsupported-fn");
const round = (0, create_fn_1.createFn)("fn.math.round", (args, context) => {
    const value = (0, get_arg_1.getArgNumberOrUndefined)(args, 1, context);
    if (value === undefined) {
        return undefined;
    }
    return Math.round(value);
});
const max = (0, create_fn_1.createFn)("fn.math.max", (args, context) => {
    const maxArgs = [];
    for (let i = 1; i <= args.length; i += 1) {
        const value = (0, get_arg_1.getArgNumberOrUndefined)(args, i, context);
        if (value !== undefined) {
            maxArgs.push(value);
        }
    }
    if (maxArgs.length === 0) {
        return undefined;
    }
    return Math.max(...maxArgs);
});
const min = (0, create_fn_1.createFn)("fn.math.min", (args, context) => {
    const minArgs = [];
    for (let i = 1; i <= args.length; i += 1) {
        const value = (0, get_arg_1.getArgNumberOrUndefined)(args, i, context);
        if (value !== undefined) {
            minArgs.push(value);
        }
    }
    if (minArgs.length === 0) {
        return undefined;
    }
    return Math.min(...minArgs);
});
function mapDecimalRoundMethod(method) {
    switch (method) {
        case "up":
            return Math.ceil;
        case "down":
            return Math.floor;
        case "even":
            return Math.round;
        default:
            throw new Error(`fn.math.decimalround: Expected the 3rd arg to be one of "up", "down", or "even", instead "${method}" was received which is of type ${typeof method}`);
    }
}
const decimalround = (0, create_fn_1.createFn)("fn.math.decimalround", (args, context) => {
    const value = (0, get_arg_1.getArgNumberOrUndefined)(args, 1, context);
    if (value === undefined) {
        return "";
    }
    const decimals = (0, get_arg_1.getArgNumber)(args, 2, context);
    const method = (0, get_arg_1.getArgStringOrUndefined)(args, 3, context) || "even";
    const precision = Math.pow(10, decimals);
    return (mapDecimalRoundMethod(method)(value * precision) / precision).toFixed(decimals);
});
const asymmetricround = (0, unsupported_fn_1.unsupportedFn)("fn.math.asymmetricround");
const log = (0, create_fn_1.createFn)("fn.math.log", (args, context) => {
    const value = (0, get_arg_1.getArgNumberOrUndefined)(args, 1, context);
    if (value === undefined) {
        return undefined;
    }
    return Math.log(value);
});
const ceiling = (0, create_fn_1.createFn)("fn.math.ceiling", (args, context) => {
    const value = (0, get_arg_1.getArgNumberOrUndefined)(args, 1, context);
    if (value === undefined) {
        return undefined;
    }
    return Math.ceil(value);
});
const haversine = (0, unsupported_fn_1.unsupportedFn)("fn.math.haversine");
const pow = (0, create_fn_1.createFn)("fn.math.pow", (args, context) => {
    const value = (0, get_arg_1.getArgNumberOrUndefined)(args, 1, context);
    const power = (0, get_arg_1.getArgNumber)(args, 2, context);
    if (value === undefined) {
        return undefined;
    }
    return Math.pow(value, power);
});
const sqrt = (0, create_fn_1.createFn)("fn.math.sqrt", (args, context) => {
    const value = (0, get_arg_1.getArgNumberOrUndefined)(args, 1, context);
    if (value === undefined) {
        return undefined;
    }
    return Math.sqrt(value);
});
exports.math = {
    round,
    max,
    min,
    decimalround,
    asymmetricround,
    log,
    ceiling,
    haversine,
    pow,
    sqrt,
};
//# sourceMappingURL=math.js.map